import React from "react";
import { Heading } from "@flixbus/honeycomb-react";
import { Icon, IconInfoSolid } from "@flixbus/honeycomb-icons-react";
import styles from "./CalculationEmptyState.module.scss";

const CalculationEmptyState: React.FC = () => (
  <div className={styles.container}>
    <Icon InlineIcon={IconInfoSolid} extraClasses={styles.icon} />
    <Heading size={4} flushSpace>
      {'Add costs using the "Add Cost" button to see your results.'}
    </Heading>
  </div>
);

export default React.memo(CalculationEmptyState);
